import { Link } from 'react-router-dom';

import icFiscal from '@/assets/ic_fiscal.jpg';
import ROUTES from '@/router/routes';
import { cn } from '@/utils';

type Props = {
  className?: string;
};

export const Footer = ({ className }: Props) => {
  return (
    <footer
      className={cn(
        'lg:bg-gradient-to-b from-[#0A3DD1] to-[#212F6F] px-4',
        className
      )}
    >
      <div className="flex flex-col lg:flex-row items-center mx-auto lg:justify-between h-[5.375rem] max-w-[70.5rem]">
        <div className="flex items-center">
          <Link
            className="text-white text-3xs lg:text-xs underline-offset-4 hover:text-gray-300 lg:order-5 underline font-light lg:font-normal"
            id="linkPolitics"
            target="_blank"
            to="/pdf/Reglamento_Gran_DT.pdf#page=23"
          >
            Política de Privacidad
          </Link>
          <span className="text-white lg:order-2 mx-4">|</span>
          <Link
            className="text-white text-3xs lg:text-xs underline-offset-4 hover:text-gray-300 lg:order-1 underline font-light lg:font-normal"
            id="linkRegulation"
            target="_blank"
            to="/pdf/Reglamento_Gran_DT.pdf"
          >
            Reglamento
          </Link>
          <span className="mx-4 text-white lg:order-4"> | </span>
          <Link
            className="text-white text-3xs lg:text-xs underline-offset-4 hover:text-gray-300 lg:order-3 underline font-light lg:font-normal"
            id="linkFaq"
            target="_blank"
            to={ROUTES.preguntasFrecuentes}
            type="button"
          >
            Preguntas Frecuentes
          </Link>
        </div>

        <div className="flex items-center lg:hidden">
          <Link
            className="text-white text-3xs lg:text-xs no-underline hover:text-gray-300 font-light"
            id="linkEmail"
            to="mailto:consultas@grandt.com.ar"
          >
            consultas@grandt.com.ar
          </Link>
          <span className="mx-2 text-white"> | </span>
          <Link
            className="text-white text-3xs lg:text-xs no-underline hover:text-gray-300 font-light"
            id="linkPhone"
            to="tel:+5491108003332343"
          >
            0800-333-2343
          </Link>
        </div>

        <p className="text-xs hidden lg:flex no-underline text-white items-center space-x-3.5 font-light tracking-[.025rem]">
          <span>
            Copyright 2008 / Clarín / Gran DT. Todos los derechos reservados
          </span>
          <Link
            target="_F960AFIPInfo"
            to="http://qr.afip.gob.ar/?qr=Mmb3BHRA7F4ZpHnURBWOBA,,"
          >
            <img
              alt="Gran DT - Logo Fiscal"
              className="w-[1.625rem]"
              src={icFiscal}
            />
          </Link>
        </p>
      </div>
    </footer>
  );
};
